import { useState } from 'react'

import { Tabs } from '@components/designSystem/Tabs'

import type { Key } from 'react-aria-components'

const baseTabs = [
  { id: 'details', label: 'My details' },
  { id: 'profile', label: 'Profile' },
  { id: 'password', label: 'Password', badge: 3 },
  { id: 'security', label: 'Security' },
]

function ExampleBlock({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="mb-10">
      <h3 className="mb-3 text-md font-semibold text-secondary">{title}</h3>
      {children}
    </div>
  )
}

function TabsDemo() {
  const [selectedFullWidth, setSelectedFullWidth] = useState<Key>('details')

  return (
    <section className="space-y-12">
      <h2 className="text-xl font-bold">Tabs Component Demo</h2>

      <ExampleBlock title="Full Width Underline (fills container)">
        <div className="w-full rounded-md border border-border-secondary p-4">
          <Tabs selectedKey={selectedFullWidth} onSelectionChange={setSelectedFullWidth} className="w-full">
            <Tabs.List type="underline" fullWidth items={[...baseTabs]}>
              {(tab) => <Tabs.Item {...tab} />}
            </Tabs.List>

            <div className="mt-3 space-y-2 rounded-md border border-border-secondary p-3 text-sm">
              {baseTabs.map((item) => (
                <Tabs.Panel key={item.id} id={item.id}>
                  <strong className="mb-1 block">{item.label}</strong>
                  <p className="text-quaternary">
                    Panel content for “{item.id}”. You can place any JSX here.
                  </p>
                </Tabs.Panel>
              ))}
            </div>
          </Tabs>
        </div>
      </ExampleBlock>
    </section>
  )
}

export default TabsDemo
